import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The Venia storefront looks best when running against a Magento 2 backend with the Venia sample data installed.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`buildpack create-env-file`}</inlineCode>{` command defaults to the URL for a Magento 2 cloud instance that has the Venia sample data installed, so
setting up a Magento 2 instance and installing sample data into it is now an optional step.`}</p>
    <p>{`Follow the instructions on this page to install the Venia sample data into your Magento 2 development instance.`}</p>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`PHP 7.4+`}</li>
      <li parentName="ul">{`System access to a Magento 2 instance`}</li>
    </ul>
    <p>{`If you have the previous `}<inlineCode parentName="p">{`magento2-sample-data`}</inlineCode>{` module installed, you need to `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/installation-guide/next-steps/sample-data/remove-or-update.html"
      }}>{`remove the sample data modules`}</a>{` and re-install Magento with a clean database.`}</p>
    <h2 {...{
      "id": "step-1-set-the-composer-repository-in-the-config"
    }}>{`Step 1. Set the composer repository in the config`}</h2>
    <p>{`Run the following command in the Magento root directory setup the repository for the sample data in `}<a parentName="p" {...{
        "href": "https://repo.magento.com"
      }}>{`https://repo.magento.com`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`composer config --no-interaction --ansi repositories.venia-sample-data composer https://repo.magento.com
`}</code></pre>
    <h2 {...{
      "id": "step-2-require-in-the-sample-data"
    }}>{`Step 2. Require in the sample data`}</h2>
    <p>{`Run the following command in the Magento root directory to update the `}<inlineCode parentName="p">{`composer.json`}</inlineCode>{` to require in `}<inlineCode parentName="p">{`magento/venia-sample-data`}</inlineCode>{` metapackage:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`composer require --no-interaction --ansi magento/venia-sample-data:*
`}</code></pre>
    <h2 {...{
      "id": "step-3-install-the-sample-data-modules"
    }}>{`Step 3. Install the sample data modules`}</h2>
    <p>{`Run the following command in the Magento root directory to install the Venia data from the modules:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`bin/magento setup:upgrade
`}</code></pre>
    <h2 {...{
      "id": "step-4-reindex-the-new-data"
    }}>{`Step 4. Reindex the new data`}</h2>
    <p>{`Run the following command in the Magento root directory to reindex the data from the modules:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`bin/magento indexer:reindex
`}</code></pre>
    <h2 {...{
      "id": "step-5-verify-installation"
    }}>{`Step 5. Verify installation`}</h2>
    <p>{`Log into the Admin section or visit the store of your Magento instance to verify the sample data installation.`}</p>
    <p><img alt="Sample data installed in Magento" src={require("./images/sample-data-installed.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      